import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Input from "../../Common/Input";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [steps, setSteps] = useState({ email: false, otp: false });
  const isOtpScreen = steps.email === true && steps.otp === false;
  const isPasswordScreen = steps.email === true && steps.otp === true;

  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleOtpChane = (e) => {
    setOtp(e.target.value);
  };

  const getCTAText = () => {
    if (isPasswordScreen) {
      return "Create Account";
    }
    if (isOtpScreen) {
      return "Verify OTP";
    }
    return "Sign up";
  };

  const generateOtp = async () => {
    if (isPasswordScreen) {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/student/sendOTP`,
        { email },
      );
      setSteps((prev) => ({ ...prev, email: true }));
   
    } else {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/student/verifyOTP`,
        { email, otp },
      );
      setSteps((prev) => ({ ...prev, otp: true }));
      
    }
  };

  return (
    <div className="flex flex-col justify-center min-h-full px-6 py-12 mx-auto lg:px-8 lg:w-1/2">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img
          className="w-auto h-10 mx-auto"
          src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
          alt="Your Company"
        />
        <h2 className="mt-10 text-2xl font-bold leading-9 tracking-tight text-center text-gray-900">
          Create a new account
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <div className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Email address
            </label>
            <div className="mt-2">
              <Input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={handleEmailChange}
                required={true}
                disabled={steps.email === true}
              />
            </div>
          </div>
          {isOtpScreen && (
            <div>
              <label
                htmlFor="otp"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Enter OTP
              </label>
              <div className="mt-2">
                <Input
                  id="otp"
                  name="otp"
                  type="text"
                  value={otp}
                  onChange={handleOtpChane}
                  required={true}
                />
              </div>
            </div>
          )}
          {}

          {/* <div>
            <div className="flex items-center justify-between">
              <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">Password</label>
              <div className="text-sm">
                <a href="#" className="font-semibold text-indigo-600 hover:text-indigo-500">Forgot password?</a>
              </div>
            </div>
            <div className="mt-2">
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={handlePasswordChange}
                required
                className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div> */}

          <div>
            <button
              type="submit"
              onClick={generateOtp}
              className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              {getCTAText()}
            </button>
          </div>
        </div>

        <p className="mt-10 text-sm text-center text-gray-500">
          Already have an account?&nbsp;
          <a
            onClick={() => navigate("/login")}
            className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
          >
            Sign in
          </a>
        </p>
      </div>
    </div>
  );
};

export default Signup;
